<template>
  <article>
    <div class="display1">
      <!-- 统计日期:<Input v-model="name" style="width: 100px" /> -->
      日期：<DatePicker type="date" style="width: 200px;margin:0 50px 0 0;" v-model="statisticdate" format="yyyy-MM-dd"
        @on-change="dateChange"></DatePicker>
    </div>
    <div class="display1">
      <!-- 线路:<Input v-model="modelid" style="width: 100px" /> -->
      线路：<Select v-model="selectmodelid" @on-change="listChange1" style="width:200px;margin:0 50px 0 0;">
        <Option v-for="item in modelid" :value="item.ID" :key="item.ID">{{ item.LineName }}</Option>
      </Select>
      <Button size="small" type="primary" style="background: #2B85E4;" @click="submit()">提交</Button>
    </div>

    <div v-if="aaa!=''">
      <table width="100%" border="1" cellspacing="1" cellpadding="4" align="center">
        <tr>
          <th>时间</th>
          <th v-for="(item,index) in tableHead" :key="index">{{item}}</th>
        </tr>
        <tr v-for="(item1,index) in aaa" :key="index">
          <td>{{item1.SetDate}}</td>
          <td v-for="(item2,index) in tablevle[index]" :key="index">{{item2.vle}}</td>
        </tr>
      </table>
      <!-- <Table border :columns="columns1" :data="data1" show-summary :summary-method="handleSummary" height="500"></Table> -->
    </div>


  </article>
</template>

<script>
  import orderApi from '../request/orderApi';
  import userApi from '../request/userApi';

  export default {
    name: 'GetOrderStatistics',
    data() {
      return {
        // columns1: [{
        //     title: '时间',
        //     key: '日期',
        //     fixed: 'left'
        //   },
        //   {
        //     title: '前台售票',
        //     key: '前台售票'
        //   },
        // ],
        // data1: [],
        statisticdate: '',
        selectmodelid:'',
        modelid: '',

        tableHead: [],
        tablevle: [],
        add: [],
        aaa: [],
      };
    },
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#EAF3FA;overflow-y: scroll;height: auto;');
      this.GetOrderStatistics()
    },
    methods: {
      dateChange(date) {
        this.statisticdate = date;
      },
      listChange1(date){
        this.selectmodelid = date;
      },
      GetOrderStatistics(){
        orderApi.getBusLineModelList().then(listRes => {
          console.log(listRes)
          this.modelid=listRes.data
        })
      },

      submit() {
        console.log(this.statisticdate)
        console.log(this.selectmodelid)
        this.tableHead = [];
        this.tablevle = [];
        this.add = [];
        this.aaa = [];
        orderApi.GetOrderStatistics(this.statisticdate, this.selectmodelid).then(StatisticsRes => {
          console.log(StatisticsRes)
          if(StatisticsRes.Success==true&&StatisticsRes.Data!=null){
            for (var j = 0; j < StatisticsRes.Data[0].OrderStaisticsItemViewModels.length; j++) {
              this.tableHead.push(StatisticsRes.Data[0].OrderStaisticsItemViewModels[j].name);
            }
            
            for (var i = 0; i < StatisticsRes.Data.length; i++) {
              this.tablevle.push(StatisticsRes.Data[i].OrderStaisticsItemViewModels)
            }
            
            this.aaa = StatisticsRes.Data;
            // console.log('000000000',this.tableHead)
            console.log('123132', this.tablevle)
          }
          else{
            this.$Message.error(StatisticsRes.Msg);
          }
          
          // this.data1=[{"日期": "2021-08-19","前台售票": "5"},{"日期": "2021-08-17","前台售票": "25"},{"日期": "2021-08-19","前台售票": "10"}]

        })
      },

      // handleSummary({
      //   columns,
      //   data
      // }) {
      //   const sums = {};
      //   columns.forEach((column, index) => {
      //     const key = column.key;
      //     if (index === 0) {
      //       sums[key] = {
      //         key,
      //         value: '合计'
      //       };
      //       return;
      //     }
      //     const values = data.map(item => Number(item[key]));
      //     if (!values.every(value => isNaN(value))) {
      //       const v = values.reduce((prev, curr) => {
      //         const value = Number(curr);
      //         if (!isNaN(value)) {
      //           return prev + curr;
      //         } else {
      //           return prev;
      //         }
      //       }, 0);
      //       sums[key] = {
      //         key,
      //         value: v
      //       };
      //     } else {
      //       sums[key] = {
      //         key,
      //         value: '0'
      //       };
      //     }
      //   });
      //   return sums;
      // },

    }
  };
</script>

<style scoped lang="less">
  .demo-tabs-style1>.ivu-tabs-card>.ivu-tabs-content {
    height: 120px;
    margin-top: -16px;
  }

  .demo-tabs-style1>.ivu-tabs-card>.ivu-tabs-content>.ivu-tabs-tabpane {
    background: #fff;
  }

  .demo-tabs-style1>.ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab {
    border-color: transparent;
  }

  .demo-tabs-style1>.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active {
    border-color: #fff;
  }

  .srcoll_content {
    width: 98%;
    margin: -2% 5% 0 5%;
  }

  .display1 {
    display: flex;
    margin-left: 15px;
    padding-top: 5px;
    margin-bottom: 10px;
    line-height: 30px;
  }

  .input {
    margin: 10px 2% 20px;
    width: 96%;
    border: 1px solid #2B85E4;
    border-radius: 5px;
  }

  .inputBtn {
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .inputBtn Button {
    background: #2B85E4;
    margin: 15px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/GetOrderStatistics.vue